import produce from 'immer'

import { FETCH_CONFIGURATION, FETCH_CONFIGURATION_SUCCESS, FETCH_CONFIGURATION_FAILURE } from '../actions/types'

export const initialState = {
  elastic: null,
  contentGraph: null,
  redis: null,
  indexerQueue: null,
  selene: null,
  s3Bucket: null,

  error: null,
  fetched: false,
  fetching: false,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case FETCH_CONFIGURATION: {
      draft.fetching = true
      break
    }
    case FETCH_CONFIGURATION_SUCCESS: {
      const { elastic, contentGraph, redis, indexerQueue, s3Bucket, selene } = payload
      draft.error = null
      draft.fetching = false
      draft.fetched = true
      draft.elastic = elastic
      draft.contentGraph = contentGraph
      draft.redis = redis
      draft.indexerQueue = indexerQueue
      draft.s3Bucket = s3Bucket
      draft.selene = selene
      break
    }
    case FETCH_CONFIGURATION_FAILURE: {
      const error = payload
      draft.fetching = false
      draft.fetched = true
      draft.error = error
      break
    }
    default:
      // Nothing to do
      break
  }
}, initialState)
